import React from 'react';

const TrackRouteSideBarBody = () => {
    return (
        <div>
            {/* Your component content goes here */}
        </div>
    );
};

export default TrackRouteSideBarBody;